import { loadable } from '@change-corgi/core/react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'decision-maker-profile',
		path: '/decision-makers/:slug',
		component: loadable(async () => import(/* webpackChunkName: "pages/decision_maker_profile" */ './index'), {
			exportName: 'DecisionMakerProfile',
			fallback: Loading,
		}),
		frame: true,
		ssr: {
			// switch this to true to enable SSR
			enabled: true,
			seo: true,
		},
	},
];
